import { DictionariesService, DictionaryItem } from "@sa/rep-mdm";
import { arrayByLength } from "../../../../../shared";

export async function getDefaultMark(dictionariesService: DictionariesService) {
  const dictionaryCalendar = await dictionariesService.getDictionary({
    id: 'calendar-origin',
    parameters: {},
  });
  const calendarItems = await dictionaryCalendar.getAll();
  const currentYearId = Number(`1${(new Date()).getFullYear()}0101`);
  const [countLastYears, yearStep, monthFrequency, weekFrequency] = [5, 10000, 4, 7];
  const yearsIds = arrayByLength(countLastYears).map((_, i) => currentYearId - (i * yearStep));
  const sordetItems = calendarItems.sort((a, b) => Number(a.id) - Number(b.id));
  const allChildren = sordetItems.reduce((result, item) => {
    const isPrimaryChild = yearsIds.includes(Number(item.id));
    const parentId = item.getValue<number | string>("parent")?.toString();
    const isSecondaryChild = result.some(parentCandidate => parentCandidate.id === parentId);
    const isChild = isPrimaryChild || isSecondaryChild;
    if (isChild) {
      result.push(item);
    }
    return result;
  }, [] as DictionaryItem[]);

  const calendarValuesItems = allChildren.filter(item => weekFrequency === item.getValue<number | string>("frequencyId"));
  const calendarDisplayItems = allChildren.filter(item => {
    const itemFrequency = item.getValue<number | string>("frequencyId");
    return monthFrequency === itemFrequency;
  });

  return {
    calendar: calendarValuesItems.map(item => Number(item.id)),
    calendarDisplay: calendarDisplayItems.map(item => Number(item.id)),
  };
}